import { render, staticRenderFns } from "./ServiceDetails.vue?vue&type=template&id=7795161c&scoped=true&"
import script from "./ServiceDetails.vue?vue&type=script&lang=js&"
export * from "./ServiceDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7795161c",
  null
  
)

export default component.exports